module.exports = __webpack_public_path__ + "static/media/brand-refresh-location-pin-prominent.bcedd383.svg";